import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { FirebaseService } from '../../services/firebase.service';
import { SnackBarService } from '../../services/snack-bar.service';

import { ModalComponent }  from '../modal/modal';

import * as _ from 'lodash';

import { List } from '../../models/list';

@Component({
  selector    : 'manage-sharing-modal',
  templateUrl : 'manage-sharing-modal.html',
  styleUrls   : [ 'manage-sharing-modal.scss' ]
})

export class ManageSharingModalComponent implements OnInit {
  @Input() list : List;

  @ViewChild(ModalComponent)
  private modalPassthrough : ModalComponent;

  email             : string;
  emailNormalized   : string;
  profilePhoto      : string;
  collaborators     : Array<any> = [];
  collaboratorEmail : string;

  constructor(
    public firebaseService  : FirebaseService,
    private snackBarService : SnackBarService
  ) {}

  ngOnInit() : void {
    this.initUser();
    this.initCollaborators();
  }

  initUser() : void {
    this.firebaseService.user
      .subscribe(user => {
        this.email           = user.email;
        this.emailNormalized = user.emailNormalized;
        this.profilePhoto    = user.profilePhoto;
      });
  }

  initCollaborators() : void {
    this.firebaseService.getCollaborators(this.list.$key)
      .subscribe(data => {
        this.collaborators = _.sortBy(data, ['createdAt']);

        // unwrap collaborator data
        for (const collaborator of this.collaborators)
          collaborator.data
            .subscribe(data => collaborator.data = data);
      });
  }

  public show() : void {
    this.modalPassthrough.show();
  }

  public hide() : void {
    this.modalPassthrough.hide();
  }

  addCollaborator() : void {
    if (!this.validCollaborator())
      return;

    this.firebaseService.addCollaborator(this.list.$key, this.collaboratorEmail)
      .take(1)
      .subscribe(response => {
        let snackMsg = {
          message         : response.success ? 'List shared with' : 'Unable to find',
          emphasisMessage : response.collaborator.email
        };

        if (response.success) {
          snackMsg['action'] = 'UNDO';
          this.collaboratorEmail = null;
        }

        this.snackBarService.show(snackMsg)
          .then(undo => {
            if (undo)
              this.firebaseService.removeCollaborator(this.list.$key, response.collaborator.uid)
                .then(() => this.collaboratorEmail = response.collaborator.email);
          });
      });
  }

  validCollaborator() : boolean {
    let valid : boolean = true,
      snackMsg = {};

    const collabNormalized : string = this.collaboratorEmail.toLowerCase(),
      priorAccessTest : Function = (testEmail) => {
        if (collabNormalized === testEmail) {
          valid = false;

          snackMsg['message'] = 'User already has access to list';
        }
      };

    // don't share list with yourself
    priorAccessTest(this.emailNormalized);

    // don't share with someone who already has access
    for (const collab of this.collaborators) {
      priorAccessTest(collab.data.emailNormalized);
    }

    if (!valid)
      this.snackBarService.show(snackMsg);

    return valid;
  }

  removeCollaborator(collaboratorID : string, name : string) : void {
    this.firebaseService.updateCollaborator(this.list.$key, collaboratorID, { deadManWalking : true });

    this.snackBarService.show({
      message         : 'Removed access from',
      emphasisMessage : name,
      action          : 'UNDO'
    })
    .then(undo => {
      if (undo)
        this.firebaseService.updateCollaborator(this.list.$key, collaboratorID, { deadManWalking : false });
      else
        this.firebaseService.removeCollaborator(this.list.$key, collaboratorID);
    });
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/manage-sharing-modal/manage-sharing-modal.ts